import React from 'react';
import { OpportunityEmailDto, OpportunityEmailSender } from 'src/api/v2';
import { Card } from '@innovationnorway/cl-react';
import { useTranslation } from 'react-i18next';

type EmailThreadProps = {
  emails: OpportunityEmailDto[] | undefined;
};

const EmailThread: React.FC<EmailThreadProps> = ({ emails }) => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  if (!emails || emails.length === 0) {
    return (
      <div className="email-thread width--100">
        <p className="email-thread__fallback-text">
          {tOneWayIn('communication.emailThreadFallback.p1')} <u>kundemottak@enveiinn.no</u>.
        </p>
        <p className="email-thread__fallback-text">{tOneWayIn('communication.emailThreadFallback.p2')}</p>
        <p className="email-thread__fallback-text">{tOneWayIn('communication.emailThreadFallback.p3')}</p>
        <p className="email-thread__fallback-text">{tOneWayIn('communication.emailThreadFallback.p4')}</p>
      </div>
    );
  }

  return (
    <div className="email-thread">
      {emails.map((email, index) => {
        const isClusterEmail = email.sender === OpportunityEmailSender.Cluster;

        return (
          <Card
            key={index}
            className={`email-log email-log__message ${isClusterEmail ? 'cluster' : 'customer'}`}
            variant="tinted"
            data-color={isClusterEmail ? 'accent' : 'neutral'}
          >
            <Card.Block
              className="email-log__content"
              dangerouslySetInnerHTML={{ __html: email.bodyText }}
            ></Card.Block>
          </Card>
        );
      })}
    </div>
  );
};

export default EmailThread;
